import React from "react";
import {
  makeStyles,
  createStyles,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import { Translate } from "react-localize-redux";
import {
  Controller,
  Control,
  FieldError,
  NestDataObject,
} from "react-hook-form";

const useStyles = makeStyles(() =>
  createStyles({
    radioRoot: {
      color: "var(--col-navy-500)",
    },
    radioRootError: {
      color: "var(--col-accent-magnesium-500)",
    },
    errorLabel: {
      color: "var(--col-accent-magnesium-500)",
      fontSize: "12px",
      display: "flex",
    },
  })
);

interface GenderSelectionProps {
  control: Control;
  errors: NestDataObject<Record<string, any>, FieldError>;
}

export const GenderSelection: React.FC<GenderSelectionProps> = ({
  control,
  errors,
}) => {
  const classes = useStyles();

  return (
    <Translate>
      {({ translate }) => (
        <div style={{ color: "var(--col-navy-500)" }}>
          <Controller
            name="gender"
            control={control}
            defaultValue=""
            rules={{ required: true }}
            onChange={([event]) => event.target.value}
            as={
              <RadioGroup row aria-label="gender">
                <FormControlLabel
                  value="Female"
                  control={
                    <Radio
                      className={`${classes.radioRoot} ${
                        errors?.["gender"] ? classes.radioRootError : ""
                      }`}
                      color="secondary"
                    />
                  }
                  label={translate("register.Ms/Mrs")}
                />
                <FormControlLabel
                  value="Male"
                  control={
                    <Radio
                      className={`${classes.radioRoot} ${
                        errors?.["gender"] ? classes.radioRootError : ""
                      }`}
                      color="secondary"
                    />
                  }
                  label={translate("register.Mr")}
                />
                <FormControlLabel
                  value="RatherNotSay"
                  control={
                    <Radio
                      className={`${classes.radioRoot} ${
                        errors?.["gender"] ? classes.radioRootError : ""
                      }`}
                      color="secondary"
                    />
                  }
                  label={translate("register.RatherNotSay")}
                />
              </RadioGroup>
            }
          />
          {errors?.["gender"] && (
            <span className={classes.errorLabel}>
              {translate("validation.required")}
            </span>
          )}
        </div>
      )}
    </Translate>
  );
};
